import React, { useState } from 'react';
import Header from '@/components/shared/Header';
import BottomNav from '@/components/shared/BottomNav';
import MonthComparison from './MonthComparison';
import YearlySummary from './YearlySummary';
import MerchantAnalysis from './MerchantAnalysis';
import CategoryDeepDive from './CategoryDeepDive';

const TABS = [
  { id: 'compare',  label: 'Month Compare' },
  { id: 'yearly',   label: 'Yearly View' },
  { id: 'merchant', label: 'Merchant' },
  { id: 'category', label: 'Category' },
];

export default function Analytics() {
  const [activeTab, setActiveTab] = useState('compare');

  return (
    <div className="flex flex-col h-full">
      <Header
        title="📊 Analytics"
        bgColor="bg-gray-800"
        subtitle="Trends · Comparisons · Insights"
      />

      {/* Tabs */}
      <div className="flex bg-gray-800 px-3 pb-3 gap-2 overflow-x-auto scrollbar-none">
        {TABS.map(tab => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`px-3 py-1.5 rounded-chip text-xs font-semibold whitespace-nowrap transition-colors
              ${activeTab === tab.id ? 'bg-white/20 text-white' : 'text-white/50 hover:text-white/80'}`}
            aria-selected={activeTab === tab.id}
            role="tab"
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="flex-1 overflow-y-auto scrollbar-none pb-20 p-3 fade-in">
        {activeTab === 'compare'  && <MonthComparison />}
        {activeTab === 'yearly'   && <YearlySummary />}
        {activeTab === 'merchant' && <MerchantAnalysis />}
        {activeTab === 'category' && <CategoryDeepDive />}
      </div>

      <BottomNav />
    </div>
  );
}
